import { useNavigate } from 'react-router';

export const getToInitials = (fullName) => {
    if (!fullName) return 'M';
    const namesArray = fullName.trim().split(' ');
    if (namesArray.length === 1) return `${namesArray[0].charAt(0)}`;
    else return `${namesArray[0].charAt(0)}${namesArray[namesArray.length - 1].charAt(0)}`;
}

export const encode = (str) => {
    var encoded = "";
    for (var i = 0; i < str.length; i++) {
        var a = str.charCodeAt(i);
        var b = a ^ 42;    // bitwise XOR with any number, e.g. 123
        encoded = encoded + String.fromCharCode(b);
    }
    return encoded;
}

export const readFile = async (file) => {
    return await fetch(file)
        .then(response => response.text())
        .then(data => {
            return data;
        })
        .catch(() => {
            return '';
        });
}

export const formatDate = (date) => {
    return new Date(date).toLocaleString(undefined, {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        weekday: "short",
        hour: '2-digit',
        hour12: false,
        minute: '2-digit',
        second: '2-digit',
    });
}

export const firstLetterCapital = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const formatFileSize = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export const arrayToSentence = (arr) => {
    if (arr.length === 1) return arr[0];
    var last = arr.pop();
    return arr.join(', ') + ' and ' + last;
}

export const fileIcon = (ext) => {
    const exts = ['3ds', 'aac', 'ai', 'avi', 'bmp', 'cad', 'cdr', 'css', 'dat', 'dll', 'dmg', 'doc', 'docx', 'eps', 'fla', 'flv', 'gif', 'html', 'htm', 'indd', 'iso', 'jpg', 'jpeg', 'js', 'midi', 'mov', 'mp3', 'mpg', 'pdf', 'php', 'png', 'ppt', 'pptx', 'psd', 'raw', 'sql', 'svg', 'tif', 'txt', 'wmv', 'xls', 'xlsx', 'xml', 'zip', 'file',];
    return exts.includes(ext) ? `/_media/svg/files/${ext}.svg` : `/_media/svg/files/file.svg`;
}

export const formatInputDate = (timestamp) => {
    var date_not_formatted = new Date(timestamp);
    var formatted_string = date_not_formatted.getFullYear() + "-";
    if (date_not_formatted.getMonth() < 9) {
        formatted_string += "0";
    }
    formatted_string += (date_not_formatted.getMonth() + 1);
    formatted_string += "-";
    if (date_not_formatted.getDate() < 10) {
        formatted_string += "0";
    }
    formatted_string += date_not_formatted.getDate();
    return formatted_string;
}

export const isProjectOngoing = completeDate => {
    const currDate = (Date.now() / 1000);
    return completeDate > currDate;
}

export const withRouter = (Component) => {
    const Wrapper = (props) => {
        const history = useNavigate();
        return <Component history={history} {...props} />
    }
    return Wrapper;
}